import axiosPrivate from "./axiosPrivate"
import axiosWithCustomToken from  "./axiosWithCustomToken" 

export const getInstagramIds = async (businessManagerId) => {
  return axiosPrivate.get(`${businessManagerId}/instagram_accounts`)
}

export const getInstagramIdsFromFBPageId = async (fbPageId) => {
  const fields = "connected_instagram_account"
  const endpoint = `${fbPageId}?fields=${fields}`
  return axiosPrivate.get(endpoint)
}

export const getPBIAIds = async (fbPageId, fbAccessToken) => {
  return axiosWithCustomToken.get(`${fbPageId}/page_backed_instagram_accounts`, fbAccessToken)
}